import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import './tailwind.css'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus';
import router from './router/router';
import '/main.css';
import { Encrypt, Decrypt } from './utils/cryptojs';
import request from './utils/request';
import './assets/Iconfont/iconfont.css'
import { useUserStore } from './store/user'

const pinia = createPinia();
const app = createApp(App);
app.use(ElementPlus);
app.use(router);
app.use(request); // 注册请求插件
app.use(pinia);

// 检查token是否过期
const userStore = useUserStore();
userStore.checkTokenExpiry();

app.mount('#app');
app.config.globalProperties.$Encrypt = Encrypt;
app.config.globalProperties.$Decrypt = Decrypt;
